// Replaced at build time (see build.ts). Stays off unless a build sets BUN_PUBLIC_ASK_ENABLED=1.
export const ASK_ENABLED = process.env.BUN_PUBLIC_ASK_ENABLED === "1";

// True while flags are rebuilt from on-chain fills. Set false when the new detector is live.
export const FLAGS_REBUILDING = true;
